var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"u-pad-x-1of12 u-pad-y-xl u-pad-y-md--sm",class:'u-' + _vm.data.ctaPosition},[_c('app-button',{attrs:{"url":_vm.data.href}},[_c('span',{staticClass:"t-text"},[_vm._v(" "+_vm._s(_vm.data.titre)+" ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }